import { HttpPostRequest } from "clients/authenticationClient"
import config from "config/config"
import { PHRONESIS_LOGIN_CALLBACK } from "constants/paths"

interface Token {
	auth_token: string
	refresh_token: string | null
	token_duration: number
}
type PhronesisProvider = "monetization_auth"

interface LoginPayload {
	// password
	authorization_code: string
	username: string
	login_provider: PhronesisProvider
	logout_token: string
	redirect_uri: string
}

const phronesisProvider: PhronesisProvider = "monetization_auth"
const baseUrl = config.base_url
export const loginWithUsernameAndPassword = (
	username: string,
	password: string
): Promise<Token> => {
	const payload: LoginPayload = {
		authorization_code: password,
		login_provider: phronesisProvider,
		logout_token: "",
		username,
		redirect_uri: `${baseUrl}${PHRONESIS_LOGIN_CALLBACK}`,
	}

	return HttpPostRequest<Token, LoginPayload>("/login", payload)
}
